import React from 'react';
import { Sidebar } from './Sidebar';
import { QuickTicket } from './QuickTicket';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex h-screen bg-slate-50 overflow-hidden font-sans" data-id="element-185">
      <Sidebar data-id="element-186" />
      <main className="flex-1 overflow-y-auto focus:outline-none relative" data-id="element-187">
        {/* Decorative background element - Orange pittogramma */}
        <div className="absolute top-0 right-0 w-64 h-64 pointer-events-none opacity-5" data-id="element-188">
          <img src="https://cdn.magicpatterns.com/uploads/fM9z3qaiY6WQJbqFyvrZep/icona_arancione.svg" alt="" className="w-full h-full object-contain" aria-hidden="true" data-id="element-189" />
        </div>

        <div className="py-8 relative z-10 pb-32" data-id="element-190">
          <div className="max-w-[1400px] mx-auto px-8 lg:px-16" data-id="element-191">{children}</div>
        </div>
      </main>

      {/* FAB Ticket visible on every page */}
      <QuickTicket data-id="element-192" />
    </div>;
}